import classnames from 'classnames';

import './UserIcon.css';

interface UserIconProps {
  className?: string;
  size?: number;
}

/**
 * User avatar icon (circle with person silhouette).
 * Circle uses currentColor; silhouette stays white. Decorative — not interactive.
 */
function UserIcon({ className, size = 32 }: UserIconProps) {
  return (
    <svg
      aria-hidden='true'
      className={classnames('user-icon', className)}
      fill='none'
      focusable='false'
      height={size}
      role='img'
      viewBox='0 0 32 32'
      width={size}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='currentColor'
      />
      <path
        d='M18.5 12C18.5 11.125 18 10.3125 17.25 9.84375C16.4688 9.40625 15.5 9.40625 14.75 9.84375C13.9688 10.3125 13.5 11.125 13.5 12C13.5 12.9062 13.9688 13.7188 14.75 14.1875C15.5 14.625 16.4688 14.625 17.25 14.1875C18 13.7188 18.5 12.9062 18.5 12ZM12 12C12 10.5938 12.75 9.28125 14 8.5625C15.2188 7.84375 16.75 7.84375 18 8.5625C19.2188 9.28125 20 10.5938 20 12C20 13.4375 19.2188 14.75 18 15.4688C16.75 16.1875 15.2188 16.1875 14 15.4688C12.75 14.75 12 13.4375 12 12ZM10.5312 22.5H21.4375C21.1562 20.5312 19.4688 19 17.4062 19H14.5625C12.5 19 10.8125 20.5312 10.5312 22.5ZM9 23.0938C9 20 11.4688 17.5 14.5625 17.5H17.4062C20.5 17.5 23 20 23 23.0938C23 23.5938 22.5625 24 22.0625 24H9.90625C9.40625 24 9 23.5938 9 23.0938Z'
        fill='#ffffff'
      />
    </svg>
  );
}

export default UserIcon;
